import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueI18n from './language/index'
import Antd from 'ant-design-vue'
import { Popup } from 'vant';
import 'vant/lib/index.css';

import 'ant-design-vue/dist/antd.css'
import '@/assets/style/App.scss'
import '@/assets/style/base.scss'
createApp(App).use(store).use(VueI18n).use(router).use(Antd).use(Popup).mount('#app')
